import { IResponse } from "models";

export enum ActionType {
  SUBSCRIBE_SUPER_CITY = "action/SUBSCRIBE_SUPER_CITY",
  SUBSCRIBE_SUPER_CITY_SUCCESS = "action/SUBSCRIBE_SUPER_CITY_SUCCESS",
  SUBSCRIBE_SUPER_CITY_ERROR = "action/SUBSCRIBE_SUPER_CITY_ERROR",
  SUBSCRIBE_SUPER_CITY_RESET = "action/SUBSCRIBE_SUPER_CITY_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface ISubscribeSuperCityPayload {
  user_ids?: any;
  patient_ids?: any;
}

export interface ISubscribeSuperCityResponse extends IResponse {
  result: any;
}
